/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/label-has-associated-control */
import {
  Avatar,
  Box,
  Container,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  makeStyles,
} from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import ReactInputMask from 'react-input-mask'

import ufs from '../../util/uf'
import Icon from '@mdi/react'
import { mdiProgressUpload } from '@mdi/js'
import colors from '../../assets/colors'

const useStyles = makeStyles({
  uploadLogo: {
    width: '100%',
    height: '100%',
    border: `1px dashed ${colors.primary}`,
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    fontSize: '14px',
    borderRadius: '10px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: '#FFF',
      opacity: '.6',
    },
  },
  logo: {
    objectFit: 'contain',
    width: '250px',
    height: '100px',
    borderRadius: '10px',
  },
  logoValidate: {
    fontSize: '12px',
    color: colors.graylight,
  },
  logoInvalid: {
    fontSize: '12px',
    color: colors.error,
  },
  sectionTitle: {
    padding: '8px 0',
    borderTop: '1px dashed',
    borderColor: colors.textSecondary,
    borderBottom: '1px dashed',
    borderBottomColor: colors.textSecondary,
    color: colors.textPrimary,
    fontSize: '14px',
    width: '100%',
  },
})
const Form = ({ data }) => {
  const classes = useStyles()
  const [dataForm, setDataForm] = useState(data)
  const [logoValidate, setLogoValidate] = useState({
    invalidType: '',
  })

  const inputRef = useRef()

  useEffect(() => {
    setDataForm(data)
  }, [data])

  const handleChange = e => {
    e.preventDefault()
    const { name, value } = e.target

    setDataForm({
      ...dataForm,
      [name]: value,
    })
  }

  const readFileAsDataURL = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(file)
    })
  }

  const getImageDimensions = dataUrl => {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.onload = () => resolve({ width: img.width, height: img.height })
      img.onerror = reject
      img.src = dataUrl
    })
  }

  const handleChangeLogo = async event => {
    if (event.target.files[0] == null) return

    const image = event.target.files[0]

    if (!['image/png', 'image/jpeg']?.includes(image?.type)) {
      setDataForm({
        ...dataForm,
        logo: null,
        logoPath: null,
      })

      return setLogoValidate({
        ...logoValidate,
        invalidType: 'Tipo de arquivo inválido',
      })
    }

    const base64 = await readFileAsDataURL(image)
    const dimensions = await getImageDimensions(base64)

    const { width, height } = dimensions

    const maxWidth = 1200
    const maxHeight = 400

    if (width > maxWidth || height > maxHeight) {
      setLogoValidate({
        ...logoValidate,
        invalidType: `A imagem deve ter no máximo ${maxWidth}px por ${maxHeight}px ou o recomendado (169px por 32px). A imagem atual tem ${width}px por ${height}px`,
      })
      setDataForm({
        ...dataForm,
        logo: null,
        logoPath: null,
      })
      return
    }

    setDataForm({
      ...dataForm,
      logo: image,
      logoPath: base64,
    })

    setLogoValidate({
      ...logoValidate,
      invalidType: '',
    })
  }

  const buscaCep = async cep => {
    const currentCep = cep.replace(/\D/g, '')

    try {
      if (currentCep?.length === 8) {
        const resp = await axios
          .get(`https://viacep.com.br/ws/${currentCep}/json/`)
          .then(response => response?.data)

        setDataForm({
          ...dataForm,
          city: resp?.localidade,
          uf: resp?.uf,
          street: resp?.logradouro,
          neighborhood: resp?.bairro,
        })
      }
    } catch (e) {
      // console.log(e)
    }
  }

  const handleChooseFile = () => {
    inputRef.current.click()
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '32px',
      }}
    >
      <Grid container spacing="4" direction="row">
        {dataForm?.logo && !dataForm?.logoPath && (
          <Grid item xs={12}>
            <Grid container justifyContent="flex-end">
              <Box className={classes.boxLogo}>
                <img
                  alt="Logo"
                  className={classes.logo}
                  src={`data:image/png;base64,${dataForm?.logo}`}
                />
              </Box>
            </Grid>
          </Grid>
        )}

        {dataForm?.logoPath && (
          <Grid item xs={12}>
            <Grid container justifyContent="flex-end">
              <Box className={classes.boxLogo}>
                <img
                  alt="Logo"
                  className={classes.logo}
                  src={dataForm?.logoPath}
                />
              </Box>
            </Grid>
          </Grid>
        )}
        <Grid item xs="12" sm={6} md={3}>
          <TextField
            label="Nome"
            name="name"
            required
            fullWidth
            value={dataForm.name}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs="12" sm={6} md={3}>
          <TextField
            label="Email"
            name="email"
            type="text"
            fullWidth
            required
            value={dataForm.email}
            onChange={handleChange}
          />
        </Grid>

        <Grid item sm={6} xs={12} md={3}>
          <ReactInputMask
            mask="(99) 99999-9999"
            placeholder="(__) _____-____"
            name="phone"
            maskChar=""
            key={`input-phone-${dataForm?.phone}`}
            value={dataForm?.phone}
            onChange={handleChange}
            required
          >
            {inputProps => (
              <TextField {...inputProps} fullWidth label="Telefone" />
            )}
          </ReactInputMask>
        </Grid>

        <Grid item sm={6} xs={12} md={3}>
          <ReactInputMask
            mask="(99) 99999-9999"
            placeholder="(__) _____-____"
            name="cell_phone"
            maskChar=""
            key={`input-cell_phone-${dataForm?.cell_phone}`}
            value={dataForm?.cell_phone}
            onChange={handleChange}
            required
          >
            {inputProps => (
              <TextField {...inputProps} fullWidth label="Celular" />
            )}
          </ReactInputMask>
        </Grid>
      </Grid>

      <Grid container spacing="4" direction="row">
        <Grid item sm={3} xs={12} md={3}>
          <ReactInputMask
            mask="99.999-999"
            name="cep"
            maskChar=""
            value={dataForm?.cep}
            required
            onChange={handleChange}
            onBlur={() => buscaCep(dataForm?.cep)}
          >
            {inputProps => <TextField {...inputProps} label="CEP" fullWidth />}
          </ReactInputMask>
        </Grid>

        <Grid item sm={6} md={6} xs={12}>
          <TextField
            onChange={handleChange}
            label="Rua"
            name="street"
            fullWidth
            value={dataForm?.street}
            required
          />
        </Grid>

        <Grid item sm={3} md={3} xs={12}>
          <TextField
            label="Número"
            onChange={e => handleChange(e)}
            name="number"
            fullWidth
            value={dataForm?.number}
            required
            type="number"
          />
        </Grid>

        <Grid item sm={3} xs={12}>
          <TextField
            onChange={e => handleChange(e)}
            name="complement"
            label="Complemento"
            fullWidth
            value={dataForm?.complement == 'null' ? '' : dataForm?.complement}
          />
        </Grid>

        <Grid item sm={3} xs={12}>
          <TextField
            onChange={e => handleChange(e)}
            name="neighborhood"
            label="Bairro"
            fullWidth
            required
            value={dataForm?.neighborhood}
          />
        </Grid>

        <Grid item sm={6} md={3} xs={12}>
          <TextField
            onChange={e => handleChange(e)}
            name="city"
            label="Cidade"
            fullWidth
            required
            value={dataForm?.city}
          />
        </Grid>

        <Grid item sm={3} xs={12}>
          <TextField
            select
            labelId="demo-simple-select-required-label"
            id="demo-simple-select-required"
            value={dataForm?.uf}
            fullWidth
            onChange={e => handleChange(e)}
            name="uf"
            label="Estado"
            required
          >
            {ufs?.map((uf, index) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <MenuItem key={index} value={uf}>
                  {uf}
                </MenuItem>
              )
            })}
          </TextField>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={9}>
              <TextField
                maxRows={10}
                placeholder="Descrição"
                defaultValue={dataForm?.description}
                name="description"
                onChange={handleChange}
                multiline
                fullWidth
                variant="outlined"
                sx={{ margin: '1em' }}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <input
                ref={inputRef}
                name="logo"
                type="file"
                accept="image/*"
                onChange={handleChangeLogo}
                style={{ display: 'none' }}
              />
              <IconButton
                onClick={handleChooseFile}
                className={classes.uploadLogo}
              >
                <Grid container spacing={1}>
                  <Grid
                    item
                    xs={12}
                    container
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon path={mdiProgressUpload} size={1} />
                    Upload Logo
                  </Grid>
                  <Grid item xs={12}>
                    {logoValidate?.invalidType ? (
                      <Typography className={classes.logoInvalid}>
                        {logoValidate?.invalidType}
                      </Typography>
                    ) : (
                      <Typography className={classes.logoValidate}>
                        Logo (169 x 32)
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing="4" direction="row">
        <Grid item xs={12}>
          <Typography className={classes.sectionTitle}>
            Configurações de reordenação de rota
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            onChange={handleChange}
            name="departure_address"
            label="Endereço de partida"
            placeholder="Rua das Flores 123, Centro, São Paulo, 01.001-000"
            helperText="Ponto de partida da reordenação de percurso do técnico. Ex.: Rua das Flores 123, Centro, São Paulo, 01.001-000"
            fullWidth
            value={dataForm?.departure_address || ''}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            onChange={handleChange}
            name="return_address"
            label="Endereço de retorno"
            placeholder="Rua das Flores 123, Centro, São Paulo, 01.001-000"
            helperText="Endereço para onde o técnico retorna ao final do percurso. Ex.: Rua das Flores 123, Centro, São Paulo, 01.001-000"
            fullWidth
            value={dataForm?.return_address || ''}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default Form
